import clsx from "clsx"

const Home = ({ className }: { className?: string }) => (
  <div className={clsx(className)}>
    <h1 className="mb-4 text-xl leading-snug font-bold lg:text-3xl">
      Stop checking your phone! We’ll keep you on top of the markets.
    </h1>

    <p className="opacity-75">
      The simplest solution for monitoring crypto prices. Sign up, add some
      cryptocurrencies, and we’ll email you whenever prices move significantly,
      up or down.
    </p>
  </div>
)

export default Home
